import { useEffect } from "react";
import { useQuaddieMarket } from "@/hooks/firestore/betting/useQuaddieMarkets";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { mapQuaddieMarketStatus } from "@/features/betslip/utils/marketStatus";

export const useQuaddieStatusSync = (outcomeId: string, marketId: string) => {
  const { market, isLoading } = useQuaddieMarket(marketId);
  const isSyncPaused = useBetslipStore(
    (state) =>
      state.submission.phase === "submitting" ||
      state.isReviewing ||
      state.overlay.type !== "none",
  );

  useEffect(() => {
    if (isSyncPaused) return;
    if (isLoading) return;

    const status = mapQuaddieMarketStatus(market?.status);
    useBetslipStore.getState().setMarketStatus(outcomeId, status);
  }, [outcomeId, market?.status, isLoading, isSyncPaused]);
};
